export default "__VITE_ASSET__Dki1$Tni__"